import { styled } from '@spazious/dollhouse-theme';

export interface LoaderBarProps {
  progress?: number;
}

export const LoaderBar = styled.div.withConfig({
  shouldForwardProp: (prop) => !['progress'].includes(prop),
  displayName: 'LoaderBar',
})<LoaderBarProps>`
  height: 3px;
  width: 100%;
  background: var(--spz-sys-color-on-surface);
  transition: transform 200ms;
  transform-origin: left center;
  transform: scaleX(${({ progress = 0 }) => progress / 100});
`;

export default LoaderBar;
